export default __webpack_public_path__ + "static/media/sandal8.e84905a3.jpeg";